/** Bound both network and decode waits, and release the image on cancellation. */
export function loadPrintPreviewImage(url: string, signal: AbortSignal): Promise<HTMLImageElement> {
  signal.throwIfAborted();
  return new Promise((resolve, reject) => {
    const image = new Image();
    let settled = false;
    const finish = (error?: unknown) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      signal.removeEventListener('abort', onAbort);
      image.onload = null;
      image.onerror = null;
      if (error) {
        image.removeAttribute('src');
        reject(error);
      } else {
        resolve(image);
      }
    };
    const onAbort = () => finish(signal.reason);
    const timeout = setTimeout(() => finish(new Error('Preview image timed out')), 15_000);
    signal.addEventListener('abort', onAbort, { once: true });
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      void image.decode().then(
        () => finish(),
        error => finish(error),
      );
    };
    image.onerror = () => finish(new Error('Preview image failed to load'));
    image.src = url;
  });
}
